import {mapGetters} from "vuex";

export default {
  computed: {
    ...mapGetters(['loginRequestCount']),
    isLogin(){
      this.loginRequestCount;
      return this.$session.exists()
    },
    isMobile() {
      return this.$mq === 'mobile'
    },
    sessionUser() {
      this.loginRequestCount;
      return this.$session.get('loginUser') || {}
    },
    isAdmin(){
      this.loginRequestCount;
      return this.sessionUser.player_id == 1
    },
  }
}